<template>
  <div v-transfer-dom :data-transfer="transfer">
    <transition :name="transitionNames[1]">
      <div
        :class="maskClasses"
        :style="wrapStyles"
        v-show="visible"
        v-if="showMask"
        @click="handleMask"
      ></div>
    </transition>
    <div :class="wrapClasses" :style="wrapStyles" @click="handleWrapClick">
      <transition :name="transitionNames[0]" @after-leave="animationFinish">
        <div :class="classes" :style="mainStyles" v-show="visible">
          <div
            :class="contentClasses"
            ref="content"
          >
            <a :class="[prefixCls + '-close']" v-if="closable" @click="close">
              <slot name="close">
                <Icon type="ios-close"></Icon>
              </slot>
            </a>
            <div :class="[prefixCls + '-header']"  v-if="showHead">
              <slot name="header">
                <div :class="[prefixCls + '-header-inner']">{{ title }}</div>
              </slot>
            </div>
            <div :class="[prefixCls + '-body']">
              <slot></slot>
            </div>
            <div :class="[prefixCls + '-footer']" v-if="!footerHide">
              <slot name="footer">
                <i-button type="text" @click.native="cancel">{{ localeCancelText }}</i-button>
                <i-button
                  type="primary"
                  :loading="buttonLoading"
                  @click.native="ok"
                >{{ localeOkText }}</i-button>
              </slot>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import TransferDom from "../../directives/transfer-dom";
import Emitter from "../../mixins/emitter";
const prefixCls = "yjui-modal";

export default {
  name: "Modal",
  mixins: [Emitter],
  directives: { TransferDom },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: true
    },
    maskClosable: {
      type: Boolean,
      default() {
        return true;
      }
    },
    title: {
      type: String
    },
    width: {
      type: [Number, String],
      default: 520
    },
    okText: {
      type: String
    },
    cancelText: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    },
    styles: {
      type: Object,
      default() {
        return {};
      }
    },
    className: {
      type: String
    },
    // for instance
    footerHide: {
      type: Boolean,
      default: false
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    transitionNames: {
      type: Array,
      default() {
        return ["ease", "fade"];
      }
    },
    transfer: {
      type: Boolean,
      default() {
        return false;
      }
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    mask: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: Number,
      default: 1000
    }
  },
  data() {
    return {
      prefixCls: prefixCls,
      wrapShow: false,
      showHead: true,
      buttonLoading: false,
      visible: this.value
    };
  },
  computed: {
    wrapClasses() {
      return [
        `${prefixCls}-wrap`,
        {
          [`${prefixCls}-hidden`]: !this.wrapShow,
          [`${this.className}`]: !!this.className,
          [`${prefixCls}-no-mask`]: !this.showMask
        }
      ];
    },
    wrapStyles() {
      return {
        zIndex:  this.zIndex
      };
    },
    maskClasses() {
      return `${prefixCls}-mask`;
    },
    classes() {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-fullscreen`]: this.fullscreen,
          [`${prefixCls}-fullscreen-no-header`]:
            this.fullscreen && !this.showHead,
          [`${prefixCls}-fullscreen-no-footer`]:
            this.fullscreen && this.footerHide
        }
      ];
    },
    contentClasses() {
      return [
        `${prefixCls}-content`,
        {
          [`${prefixCls}-content-no-mask`]: !this.showMask
        }
      ];
    },
    mainStyles() {
      let style = {};

      const width = parseInt(this.width);
      const styleWidth ={
              width: width <= 100 ? `${width}%` : `${width}px`
            }
      

      const customStyle = this.styles ? this.styles : {};

      Object.assign(style, styleWidth, customStyle);

      return style;
    },

    localeOkText() {
      if (this.okText === undefined) {
        return this.t("i.modal.okText");
      } else {
        return this.okText;
      }
    },
    localeCancelText() {
      if (this.cancelText === undefined) {
        return this.t("i.modal.cancelText");
      } else {
        return this.cancelText;
      }
    },
    showMask() {
      return  this.mask;
    }
  },
  methods: {
/*     close() {
       console.log("this.onOk")
      this.visible = false;
      this.$emit("input", false);
      this.$emit("on-cancel");
    }, */
    handleMask() {
      if (this.maskClosable && this.showMask) {
        this.close();
      }
    },
    handleWrapClick(event) {
      const className = event.target.getAttribute("class");
      if (className && className.indexOf(`${prefixCls}-wrap`) > -1)
        this.handleMask();
    },

  /*   cancel() {
       console.log("this.onOk")
      this.close();
    },
    ok() {
       console.log("this.onOk")
      if (this.loading) {
        this.buttonLoading = true;
      } else {
        this.visible = false;
        this.$emit("input", false);
      }
      this.$emit("on-ok");
     
    }, */
    animationFinish() {
      this.$emit("on-hidden");
    },




  },
  mounted() {}
};
</script>
<style>
.yjui-modal-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
  left: 0;
  background-color: rgba(55, 55, 55, 0.6);
  height: 100%;
}
.yjui-modal-wrap {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
  left: 0;
}
.yjui-modal {
  width: auto;
  margin: 0 auto;
  position: relative;
  outline: 0;
  top: 100px;
}
.yjui-modal-content {
  position: relative;
  background-color: #fff;
  border: 0;
  border-radius: 6px;
  background-clip: padding-box;
}
.yjui-modal-body {
padding: 16px;
    font-size: 14px;
    line-height: 1.5;
}
.yjui-modal-confirm{    padding: 6px 16px 8px;}
.yjui-modal-confirm-head{padding: 0 12px 0 0;display: flex;
    justify-content: center;
    align-items: center;}
.yjui-modal-confirm-body {
    padding-left: 40px;
    font-size: 14px;
    color: #515a6e;
    position: relative;
}
.yjui-modal-confirm-footer {
  margin-top: 40px;
  text-align: right;
}
.yjui-modal-confirm-footer button+button {
    margin-left: 8px;
    margin-bottom: 0;
}
.yjui-modal-confirm-head-icon{   
    font-size: 24px;
}
.yjui-modal-confirm-head-title {
    flex: 1;
    margin-left: 12px;
    font-size: 16px;
    color: #17233d;
    font-weight: 500;
}
.yjui-modal-confirm-head-icon-confirm{color: #f90;}
.yjui-modal-confirm-head-icon-info{color: #2d8cf0;}
.yjui-modal-confirm-head-icon-success{color: #19be6b;;}
.yjui-modal-confirm-head-icon-warning{color: #f90;}
.yjui-modal-confirm-head-icon-error{color: #ed4014;}

.ease-enter-active,
.ease-appear {
  opacity: 0;
  animation-name: yjuiEaseIn;
  animation-timing-function: linear;
  animation-duration: 0.2s;
}
.ease-leave-active {
  animation-name: yjuiEaseOut;
  animation-timing-function: linear;
  animation-duration: 0.2s;
}
@keyframes yjuiEaseIn {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes yjuiEaseOut {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.9);
  }
}

.fade-enter-active,
.fade-appear {
  animation-name: yjuiFadeIn;
  opacity: 0;
  animation-timing-function: linear;
  animation-duration: 0.2s;
}
.fade-leave-active {
  animation-name: yjuiFadeOut;
  animation-timing-function: linear;
  animation-duration: 0.2s;
}
@keyframes yjuiFadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes yjuiFadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/modal/modal.vue